import { ILocationWarningState } from 'redux-state/weather-warnings/types.js';
import { PW_WARNING_BAR_LOADED } from 'utilities/consts/variable-types.js';

export const WarningsPanelHeaderLoadedEmpty = ({ warningMeta }: { warningMeta?: ILocationWarningState }) => {
  return (
    <>
      <li
        className="WeatherWarning-bar-warning-item WeatherWarning-bar-warning-item--plain"
        data-testid={PW_WARNING_BAR_LOADED}
      >
        No warnings
        {warningMeta?.warningAreaName && (
          <span className="u-sm-hidden">&nbsp;in place for {warningMeta?.warningAreaName}</span>
        )}
      </li>
    </>
  );
};
